import { createUserWithEmailAndPassword } from 'firebase/auth';
import UpdateProfileFunction from './updateProfile';


const SignupFunction = (auth,redirect,setIfAccExists,email, password, name, image) => {
    
  //to set acc exists on function call false to avoid any errors due to wrong state definition
  setIfAccExists(false);

  //firebase function to create user
  createUserWithEmailAndPassword (
    //passed as prop for authentication
    auth,
    email,
    password,
    name,
    image
    )
    .then((userCredential) => {
      // Signed up
      const user = userCredential.user;

      //called to update name and image imported from updateProfile.js
      UpdateProfileFunction(user, name,image);
      // updateProfileFunction(user,name,image);

      redirect("/ecomapp");
      // ...
    })
    .catch((err) => {

      if (err.code === "auth/email-already-in-use") {
        setIfAccExists(true);
        redirect("/ecomapp");
      }

      // ..
    });
};

export default SignupFunction;